<template lang="html">
  <div id="dealers-page">
    <section class="container oversized-container main-section">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center pb-3">
            <h2 class="common-title"> {{ $t("shared.titles.dealers") }}</h2>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 col-dealers">
          <a class="btn btn-dealer" v-bind:class="{ active: distribuidores[dInx].active == true }" v-for="(d, dInx) in distribuidores" :key="'dInx-'+dInx" @click="selectDealer(dInx)">{{ d.name }}</a>
        </div>

        <div class="col-lg-9 col-dealer-info">
          <a id="anchor-dinf"></a>

          <div class="row">
            <div class="col-md col-map">
              <div class="box-map">
                <iframe :src="dealerInfo.mapUrl" width="100%" height="600" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
              </div>
            </div>

            <div class="col-md col-information">
              <div class="box-info">
                <div class="placed-backg b-image" v-bind:style="{ backgroundImage: 'url('+dealerInfo.image+')' }"></div>

                <div class="b-text">
                  <h5 class="mb-2 name">{{ dealerInfo.name }}</h5>

                  <h6 class="label">Teléfono:</h6>
                  <p class="mb-2">{{ dealerInfo.phone }}</p>

                  <h6 class="label">Dirección:</h6>
                  <p class="mb-2">{{ dealerInfo.address }}</p>

                  <h6 class="label">Email:</h6>
                  <p>{{ dealerInfo.email }}</p>

                  <p class="mt-3">
                    <a class="btn-map t-150" target="_blank" :href="dealerInfo.btnUrl">Ver en Maps</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      dealerInfo: {
        id: null,
        name: null,
        email: null,
        phone: null,
        address: null,
        mapUrl: null,
        btnUrl: null,
        image_id: null,
        image: null,
        active: false,
      },

      distribuidores: [
        /*{
          active: false,
          "id": 1,
          "name": "San Jose Del Cabo, BCS",
          "email": "diego.campos@costawindows.com",
          "phone": "+52 624 142 1421",
          "address": "Benito Juárez #1716 San Jose del Cabo, BCS",
          "mapUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1867359.7758442203!2d-110.74081783358773!3d23.91842921607258!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86af509c6e832f3b%3A0x506d099c96608f57!2sEsloventanas!5e0!3m2!1sen!2smx!4v1587070134093!5m2!1sen!2smx\" width=\"600\" height=\"450\" frameborder=\"0\" style=\"border:0;\" allowfullscreen=\"\" aria-hidden=\"false\" tabindex=\"0\"></iframe>",
          "btnUrl": "https://maps.app.goo.gl/KDFNukPTHk6NobX39",
          "image_id": 621,
          "created_at": "2023-11-24 09:54:29",
          "updated_at": "2023-11-24 15:54:29",
          "image": "https://eslowindows.com/img/5e972da77f60f"
        },
        {
          active: false,
          "id": 2,
          "name": "Loreto, BCS",
          "email": "judithaguilart@hotmail.com",
          "phone": "613 118 2802, 613 116 6044",
          "address": "Zenith No.69, esq.  Alborada Loreto B.C.S. Mexico C.P. 23880",
          "mapUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.551100202459!2d-111.35147966016507!3d26.01985598985548!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86b43b9151d9e44f%3A0x722d2645ac88ec2e!2sCalle%20Zenith%2069%2C%20INFONAVIT%2C%20Loreto%2C%20B.C.S.!5e0!3m2!1ses-419!2smx!4v1582843289405!5m2!1ses-419!2smx",
          "btnUrl": "https://www.google.com.mx/maps/place/Calle+Zenith+69,+INFONAVIT,+Loreto,+B.C.S./@26.019856,-111.3514797,17.17z/data=!4m13!1m7!3m6!1s0x86b43b9151d9e44f:0x722d2645ac88ec2e!2sCalle+Zenith+69,+INFONAVIT,+Loreto,+B.C.S.!3b1!8m2!3d26.0198889!4d-111.3495879!3m4!1s0x86b43b9151d9e44f:0x722d2645ac88ec2e!8m2!3d26.0198889!4d-111.3495879",
          "image_id": 669,
          "created_at": "2020-04-16 14:55:31",
          "updated_at": "2020-04-16 19:55:31",
          "image": "https://eslowindows.com/img/5e9759b65c1e5"
        },
        {
          active: false,
          "id": 3,
          "name": "DF - Grupo CBCA",
          "email": "felipec@grupocbca.com",
          "phone": "045 55 4467 2190, 01 55 96 88 84 10",
          "address": "Privada de San Jose 33c Delegación Azcapotzalco México DF",
          "mapUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3761.2405971687035!2d-99.17440508509242!3d19.488281886852764!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1f86668c8b757%3A0xeef507013c7f109b!2sPriv.%20San%20Jos%C3%A9%2033%2C%20El%20Jaguey%2C%20Azcapotzalco%2C%2002519%20Ciudad%20de%20M%C3%A9xico%2C%20CDMX!5e0!3m2!1ses!2smx!4v1583435095826!5m2!1ses!2smx",
          "btnUrl": "https://www.google.com/maps/place/Priv.+San+Jos%C3%A9+33,+El+Jaguey,+Azcapotzalco,+02519+Ciudad+de+M%C3%A9xico,+CDMX/@19.4882819,-99.1744051,17z/data=!3m1!4b1!4m5!3m4!1s0x85d1f86668c8b757:0xeef507013c7f109b!8m2!3d19.4882819!4d-99.1722164",
          "image_id": 672,
          "created_at": "2020-04-16 14:59:38",
          "updated_at": "2020-04-16 19:59:38",
          "image": "https://eslowindows.com/img/5e98b92a5e2e9"
        },
        {
          active: false,
          "id": 14,
          "name": "Oficina Puerto Vallarta / Riviera Nayarit - ShowRoom",
          "email": "diego.diaz@eslowindows.com",
          "phone": "+52 33 2334 2724",
          "address": "Carretera a Tepic 5739, Locales 12 y 13, Colonia Las Juntas, Puerto Vallarta, Jalisco, México.",
          "mapUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2306.502357676428!2d-105.2496002394784!3d20.688972827588703!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjDCsDQxJzIxLjUiTiAxMDXCsDE0JzU4LjYiVw!5e0!3m2!1ses!2smx!4v1628189916554!5m2!1ses!2smx\" width=\"600\" height=\"450\" style=\"border:0;\" allowfullscreen=\"\" loading=\"lazy\"></iframe>",
          "btnUrl": "https://goo.gl/maps/geAhMoe8BX153dfg8",
          "image_id": 1271,
          "created_at": "2021-08-05 13:59:55",
          "updated_at": "2021-08-05 18:59:55",
          "image": "https://eslowindows.com/img/610c29687bd6e"
        },
        {
          active: false,
          "id": 11,
          "name": "Playa del Carmen, Q.R.",
          "email": "diego.campos@eslowindows.com",
          "phone": "984 109 2272",
          "address": "Luis Donaldo Colosio, 77728 Playa del Carmen, Q.R.",
          "mapUrl": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d29867.323264512586!2d-87.065108!3d20.652672!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc48dd0271eab7b38!2sESLOVENTANAS!5e0!3m2!1sen!2smx!4v1587070225985!5m2!1sen!2smx\" width=\"600\" height=\"450\" frameborder=\"0\" style=\"border:0;\" allowfullscreen=\"\" aria-hidden=\"false\" tabindex=\"0\"></iframe>",
          "btnUrl": "https://www.google.com.mx/maps/place/ESLOVENTANAS/@20.652672,-87.0651083,15z/data=!4m5!3m4!1s0x0:0xc48dd0271eab7b38!8m2!3d20.652672!4d-87.0651083",
          "image_id": 680,
          "created_at": "2020-04-16 15:50:45",
          "updated_at": "2020-04-16 20:50:45",
          "image": "https://eslowindows.com/img/5e98c428cb902"
        },
        {
          active: false,
          "id": 10,
          "name": "San Luis Potosi - Roberto Berrones",
          "email": "betobr15@hotmail.com",
          "phone": "(444) 188 4395",
          "address": "Carretera A Nextipac #2138, Col. Nextipac, Zapopan, Jalisco",
          "mapUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3734.815440960482!2d-103.43756918458435!3d20.59559328623465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428acecc726fff3%3A0x3434d9f3547c464a!2sEsloventanas!5e0!3m2!1sen!2smx!4v1587070553112!5m2!1sen!2smx\" width=\"600\" height=\"450\" frameborder=\"0\" style=\"border:0;\" allowfullscreen=\"\" aria-hidden=\"false\" tabindex=\"0\"></iframe>",
          "btnUrl": "https://goo.gl/maps/k83BrUjyp8fL2x67A",
          "image_id": 677,
          "created_at": "2023-02-24 11:42:37",
          "updated_at": "2023-02-24 17:42:37",
          "image": "https://eslowindows.com/img/5e98bf0cacc47"
        },
        {
          active: false,
          "id": 6,
          "name": "Leon, Guanajuato - Ventanas Tech S.A. de C.V.",
          "email": "fhernandez677@hotmail.com",
          "phone": "(477) 773 2979",
          "address": "AL. Las Torres # 1909-3, Valle del Campestre C.P.37150, Leon",
          "mapUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.9366061749774!2d-101.6971207848224!3d21.154920985930104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842bbf4e24f80971%3A0xf79a94859d544c4!2sVentanas%20Tech%20S.A.%20de%20C.V.!5e0!3m2!1ses-419!2smx!4v1582844122037!5m2!1ses-419!2smx",
          "btnUrl": "https://www.google.com/maps/place/Esloventanas/@20.5955933,-103.4375692,17z/data=!3m1!4b1!4m5!3m4!1s0x8428acecc726fff3:0x3434d9f3547c464a!8m2!3d20.5955933!4d-103.4353805e",
          "image_id": 674,
          "created_at": "2020-04-16 15:08:25",
          "updated_at": "2020-04-16 20:08:25",
          "image": "https://eslowindows.com/img/5e98bb39bd00e"
        },
        {
          active: false,
          "id": 15,
          "name": "Estado SINALOA y SONORA - Carlos Daniel Aguilar",
          "email": "carlos.aguilar@eslowindows.com",
          "phone": "+52 673 14 14 855",
          "address": "Carretera A Nextipac #2138, Col. Nextipac, Zapopan, Jalisco",
          "mapUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3734.815440960482!2d-103.43756918458435!3d20.59559328623465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428acecc726fff3%3A0x3434d9f3547c464a!2sEsloventanas!5e0!3m2!1sen!2smx!4v1587070553112!5m2!1sen!2smx\" width=\"600\" height=\"450\" frameborder=\"0\" style=\"border:0;\" allowfullscreen=\"\" aria-hidden=\"false\" tabindex=\"0\"></iframe>",
          "btnUrl": "https://goo.gl/maps/k83BrUjyp8fL2x67A",
          "image_id": 1364,
          "created_at": "2023-06-28 09:15:16",
          "updated_at": "2023-06-28 15:15:16",
          "image": "https://eslowindows.com/img/649c4cd3c0c39"
        },
        {
          active: false,
          "id": 12,
          "name": "Guadajalara, Jalisco",
          "email": "info@eslowindows.com",
          "phone": "801 759 5815",
          "address": "Carretera A Nextipac #2138, Col. Nextipac, Zapopan, Jalisco",
          "mapUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3734.815440960482!2d-103.43756918458435!3d20.59559328623465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428acecc726fff3%3A0x3434d9f3547c464a!2sEsloventanas!5e0!3m2!1sen!2smx!4v1587070532796!5m2!1sen!2smx\" width=\"600\" height=\"450\" frameborder=\"0\" style=\"border:0;\" allowfullscreen=\"\" aria-hidden=\"false\" tabindex=\"0\"></iframe>",
          "btnUrl": "https://goo.gl/maps/k83BrUjyp8fL2x67A",
          "image_id": 681,
          "created_at": "2023-02-24 11:42:15",
          "updated_at": "2023-02-24 17:42:15",
          "image": "https://eslowindows.com/img/5e98c6610ea9c"
        },
        {
          active: false,
          "id": 13,
          "name": "Nuevo Vallarta, Jalisco - Aurelio Figueroa",
          "email": "aureliofisa@hotmail.com",
          "phone": "(322) 158 5604",
          "address": "Carretera A Nextipac #2138, Col. Nextipac, Zapopan, Jalisco",
          "mapUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3734.815440960482!2d-103.43756918458435!3d20.59559328623465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428acecc726fff3%3A0x3434d9f3547c464a!2sEsloventanas!5e0!3m2!1sen!2smx!4v1587070784695!5m2!1sen!2smx\" width=\"600\" height=\"450\" frameborder=\"0\" style=\"border:0;\" allowfullscreen=\"\" aria-hidden=\"false\" tabindex=\"0\"></iframe>",
          "btnUrl": "https://goo.gl/maps/k83BrUjyp8fL2x67A",
          "image_id": 682,
          "created_at": "2023-02-24 11:42:49",
          "updated_at": "2023-02-24 17:42:49",
          "image": "https://eslowindows.com/img/5e98c755eff4c"
        },
        {
          active: false,
          "id": 16,
          "name": "Estado Nuevo León - EuroHaus",
          "email": "mike.eurohaus@gmail.com",
          "phone": "81 1106 0856",
          "address": "San José 607, Balcones de San Humberto 66320 Santa Catarina, Nuevo León, México",
          "mapUrl": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7191.062985473665!2d-100.434968!3d25.686821!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x866297f380e578a3%3A0x2fc9ba074fd79f0b!2sBalcones%20de%20San%20Humberto%2C%2066120%20Cdad.%20Santa%20Catarina%2C%20N.L.!5e0!3m2!1ses!2smx!4v1700845363236!5m2!1ses!2smx\" width=\"600\" height=\"450\" style=\"border:0;\" allowfullscreen=\"\" loading=\"lazy\" referrerpolicy=\"no-referrer-when-downgrade\"></iframe>",
          "btnUrl": "https://maps.app.goo.gl/uKQj3pzNVgu6hHFv8",
          "image_id": 1365,
          "created_at": "2023-11-24 11:04:04",
          "updated_at": "2023-11-24 17:04:04",
          "image": "https://esloventanas.com/img/6560c64588996"
        }*/
      ],
    }
  },

  methods: {
    selectDealer(d) {
      let windowW = window.innerWidth;
      this.dealerInfo = this.distribuidores[d];

      for (var i = 0; i < this.distribuidores.length; i++) {
        this.distribuidores[i].active = false;
      }

      this.distribuidores[d].active = true;

      if(windowW <= 767) {
        document.querySelector('#anchor-dinf').scrollIntoView({
          behavior: 'smooth'
        });
      }
    },

    getDealers: function(){
        axios.get(tools.url('/dealersFront')).then(
          ({data}) =>{
            this.distribuidores=data;
            this.distribuidores[0].id_tab = "v-pills-map"+ this.distribuidores[0].id;
              this.distribuidores[0].id_tab_content= "v-pills-map"+ this.distribuidores[0].id+"-tab";
              this.distribuidores[0].tabClass= "tab-pane fade show active";
              this.distribuidores[0].btnText= "Ver en Maps";

            for (var i = 1; i <= this.distribuidores.length; i++) {
              this.distribuidores[i].id_tab = "v-pills-map"+ this.distribuidores[i].id;
              this.distribuidores[i].id_tab_content= "v-pills-map"+ this.distribuidores[i].id+"-tab";
              this.distribuidores[i].tabClass= "tab-pane fade";
              this.distribuidores[i].btnText= "Ver en Maps";
            }
          });
    },
  },

  mounted() {
     this.getDealers();

    this.distribuidores[0].active = true;
    this.dealerInfo = this.distribuidores[0];
  }
};
</script>
